<template>
  <div class="ui container">
    <div class="ui left aligned">
      <div class="ui form">
        <div class="inline fields">
          <div class="field">
            <label>艺人</label>
            <select v-model="starId" @change="load()">
              <option value=""></option>
              <option value="1503945">孟美岐</option>
              <option value="1503935">吴宣仪</option>
              <option value="1661517">杨超越</option>
              <option value="1661526">段奥娟</option>
              <option value="1661534">Yamy</option>
              <option value="1661543">赖美云</option>
              <option value="1661496">张紫宁</option>
              <option value="150054">杨芸晴</option>
              <option value="1661522">李紫婷</option>
              <option value="1661523">傅菁</option>
              <option value="1661514">徐梦洁</option>
            </select>
          </div>
          <a href="http://m.v.qq.com/app/rocket_index/index.html?debug=0&act_id=200003" target="_blank">活动时间： 11月19日16点-11月23日16点</a>
        </div>
      </div>

      <vuetable ref="vuetable"
                :api-url="'/doki/' + starId"
                :fields="fields"
                :sort-order="sortOrder"
                :perPage="11"
                @vuetable:pagination-data="onPaginationData"
      >
      </vuetable>
      <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
    </div>
    <div class="ui hidden divider"></div>
    <div class="ui form">
      <div class="inline fields">
        <label>间隔</label>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="5" v-model="interval" @change="load()">
            <label>5分钟</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="15" v-model="interval" @change="load()">
            <label>15分钟</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="60" v-model="interval" @change="load()">
            <label>60分钟</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="360" v-model="interval" @change="load()">
            <label>6小时</label>
          </div>
        </div>
      </div>
    </div>
    <v-chart id="chart" :options="options" theme="light"></v-chart>
  </div>
</template>
<style>
  .form {
    padding-top: 15px;
  }
  @media screen and (min-width:960px) {
    #chart {
      width: 900px;
      height: 400px;
    }
  }
</style>
<script>
  import Vuetable from '../table/Vuetable.vue'
  import VuetablePagination from '../table/VuetablePagination.vue'
  import axios from 'axios'
  import ECharts from 'vue-echarts'

  export default {
    name: 'Doki',
    components: {
      Vuetable,
      VuetablePagination,
      'v-chart': ECharts
    },
    data () {
      return {
        starId: "",
        interval: 5,
        fields: [
          {name: 'rank', title: '排名'},
          {name: 'name', title: '姓名', callback: 'link'},
          {name: 'score', title: '火箭'},
          {name: 'time', title: '日期', callback: 'date'},
        ],
        sortOrder: [
          {
            field: 'time',
            direction: 'desc'
          }
        ],
        options: null
      }
    },
    mounted () {
      this.load();
    },
    methods: {
      onPaginationData (paginationData) {
        this.$refs.pagination.setPaginationData(paginationData)
      },
      onChangePage (page) {
        this.$refs.vuetable.changePage(page)
      },
      load: function () {
        axios.get('/doki/chart/' + this.starId + '?interval=' + this.interval).then(data => {
          let series = [];
          let legend = [];
          for (let item of data.data) {
            let name = item[0].name.replace('火箭少女101', '').replace('SNH48', '');
            series.push({
              name: name,
              type: 'line',
              data: item.map(e => [e.time, e.inc])
            });
            legend.push(name);
          }
          this.options =
              {
                title: {
                  text: '走势图'
                },
                legend: {
                  data: legend
                },
                tooltip: {
                  trigger: 'axis'
                },
                toolbox: {
                  feature: {
                    saveAsImage: {}
                  }
                },
                xAxis: {
                  type: 'time'
                },
                yAxis: {
                  type: 'value'
                },
                series: series
              };
        });
      },
      link: function (value, item) {
        return '<a href="https://v.qq.com/biu/star?id=' + item.starId + '" target="_blank">' + value + '</a>';
      },
      date: function (value) {
        let date = new Date(value);
        return date.toLocaleString();
      }
    }
  }
</script>
